import { Link } from "react-router-dom";
import { Clock, MapPin, ArrowRight } from "lucide-react";

const fmt = (n) => "₹" + n.toLocaleString("en-IN");

export const PackageCard = ({ pkg }) => (
  <Link
    to={`/tour/${pkg.slug}`}
    data-testid={`package-card-${pkg.slug}`}
    className="ll-card group block"
  >
    <div className="relative h-72 md:h-80 overflow-hidden">
      <img
        src={pkg.image}
        alt={`${pkg.title} - ${pkg.subtitle}`}
        loading="lazy"
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms] ease-out"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
      {pkg.tag && (
        <span className="absolute top-4 left-4 bg-[#f7ad2d] text-[#0A221C] text-[11px] font-bold uppercase tracking-wider py-1.5 px-3.5 rounded-full shadow-md">
          {pkg.tag}
        </span>
      )}
      <div className="absolute bottom-4 left-4 flex items-center gap-1.5 text-white/90 text-sm font-medium">
        <MapPin size={15} /> {pkg.region}
      </div>
    </div>

    <div className="p-6">
      <div className="flex items-center gap-1.5 text-[#4A5D58] text-sm mb-2">
        <Clock size={15} /> {pkg.nights}N / {pkg.days}D
      </div>
      <h3 className="font-display text-2xl font-bold text-[#0A221C] leading-tight">{pkg.title}</h3>
      <p className="text-[#4A5D58] text-sm mt-1">{pkg.subtitle}</p>

      <div className="flex items-end justify-between mt-5 pt-5 border-t border-black/5">
        <div>
          <span className="text-xs text-[#4A5D58] uppercase tracking-wide">From</span>
          <p className="font-display text-2xl font-bold text-[#0A221C]">
            {fmt(pkg.price)} <span className="text-sm font-sans font-normal text-[#4A5D58]">/ person</span>
          </p>
        </div>
        <span className="flex items-center gap-1.5 text-sm font-semibold text-[#0A221C] group-hover:text-[#4ef72d] transition-colors">
          View Details <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
        </span>
      </div>
    </div>
  </Link>
);
